import { render } from "./PlaceholderView.vue?vue&type=template&id=a98493ac&scoped=true"
import script from "./PlaceholderView.vue?vue&type=script&lang=js"
export * from "./PlaceholderView.vue?vue&type=script&lang=js"

import "./PlaceholderView.vue?vue&type=style&index=0&id=a98493ac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a98493ac"]])

export default __exports__